angular.module('tgaApp').factory('cacheInterceptor', ['$templateCache', ($templateCache) => ({
  request(config) {
    if (config.method === 'GET' && config.url.indexOf('uib') === -1) {
      // Handle template GET requests
      if (config.cache === $templateCache) {
        // Strip leading ./ from relative template paths, since it only confuses the cache key.
        config.url = config.url.replace(/^\s*\.\//, '');

        // Skip cache-busting if the template base URL is pre-cached
        if ($templateCache.get(config.url) != null) {
          return config;
        }
      }

      const cacheVersion = 1;

      if (!config.params) {
        config.params = {};
      }

      if (!config.params.v) {
        config.params.v = cacheVersion;
      }
    }
    return config;
  },
}),
]);

angular.module('tgaApp').config([
  '$httpProvider',
  function ($httpProvider) {
    $httpProvider.interceptors.push('cacheInterceptor');
  },
]);
